import React from "react";
import { ROLE_OPTIONS, STATUS_OPTIONS } from "../../../utils/Constant";


export default function UsersFilter({ role, status, onRoleChange, onStatusChange }) {
  return (
    <div className="flex gap-2">
      <select
        value={role}
        onChange={(e) => onRoleChange(e.target.value)}
        className="h-9 rounded-md border border-slate-300 bg-white px-2 text-[13px] text-slate-600 outline-none focus:border-brand-500 focus:ring-2 focus:ring-brand-500/20"
      >
        {ROLE_OPTIONS.map((o) => (
          <option key={o.value} value={o.value}>
            {o.label}
          </option>
        ))}
      </select>
      <select
        value={status}
        onChange={(e) => onStatusChange(e.target.value)}
        className="h-9 rounded-md border border-slate-300 bg-white px-2 text-[13px] text-slate-600 outline-none focus:border-brand-500 focus:ring-2 focus:ring-brand-500/20"
      >
        {STATUS_OPTIONS.map((o) => (
          <option key={o.value} value={o.value}>
            {o.label}
          </option>
        ))}
      </select>
    </div>
  );
}
